<template>
  <FiltersItem
    v-if="!isOnlyDirectFlightsAvailable"
  >
    <template #title>
      {{ $l('showresult.filter.transfersTitle') }}
    </template>
    <template #content>
      <!-- Number of stops -->
      <FiltersItemTransfersStops />
      <!-- Hide trips which require changing airports -->
      <FiltersItemTransfersChangeAirport />
      <!-- Maximum waiting time -->
      <FiltersItemTransfersMaximumWaitingTime />
    </template>
    <template #summary>
      <FiltersItemSummary :items="summaryItems" />
    </template>
  </FiltersItem>
</template>

<script setup>
import { l } from '@utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();

const isOnlyDirectFlightsAvailable = computed(() =>
	resultQueryStore.state.response.uniqueNumStops.includes(0)
	&& resultQueryStore.state.response.uniqueNumStops.length === 1
);

const summaryItems = computed(() => {
	const summary = [];

	// // Number of stops

	// if (filtered.hasOwnProperty('numStops')) {
	// 	const stops = parseInt(filtered.numStops, 10);
	// 	const texts = [
	// 		l('showresult.filter.summary.directFlightsOnly'),
	// 		l('showresult.filter.summary.maxOneStop')
	// 	];


	const numStopsText = [
		l('showresult.filter.summary.directFlightsOnly'),
		l('showresult.filter.summary.maxOneStop')
	];
	if (filtersStore.state.numStops !== null) {
		summary.push(numStopsText[filtersStore.state.numStops]);
	}

	if (filtersStore.state.changesAirport) {
		summary.push(l('showresult.filter.summary.noChangeOfAirport'));
	}

	if (filtersStore.state.airportWaitTime) {
		summary.push(l('showresult.filter.summary.excludeLongTransferTime'));
	}
	return summary;
});
</script>

<style lang="scss"></style>
